import { useEffect } from 'react';
import { useSpring, useViewportScroll } from "framer-motion/dist/framer-motion";
import useMobile from './useMobile';

const useSpringViewportScroll = () => {

  const isMobile = useMobile();
  const { scrollY } = useViewportScroll();
  const springViewportScroll = useSpring(scrollY, { damping: 80, mass: isMobile ? 0.5 : 0.8, stiffness: isMobile ? 800 : 400});

  useEffect(() => {
      springViewportScroll.set(0);
      springViewportScroll.stop();
      
      const timer = setTimeout(() => {
          window.scrollTo(0, 0);
      }, 800)

      return () => {
        clearTimeout(timer);
      }
      
  }, [springViewportScroll])
  
  return isMobile ? scrollY : springViewportScroll;

}

export default useSpringViewportScroll;